module.exports = __webpack_public_path__ + "63a3b2e2c99ad22debd238e98e83e4e1.png";